// extracted by mini-css-extract-plugin
module.exports = {"bg_img":"PRTPTeacher_bg_img__JM3QS","zoom":"PRTPTeacher_zoom__pcSgw","cardContent":"PRTPTeacher_cardContent__a_auS"};